const btnsShape = () => {
    const btns = document.querySelectorAll('.btn--secondary, .btn--tertiary, .btn--primary');
    btns?.forEach(btn => {
        const add = (Math.tan((20 * Math.PI) / 180) * btn.getBoundingClientRect().height);
        btn.style.setProperty('--padding-right', add + 8 + 'px');
        btn.style.setProperty('--width-before', btn.getBoundingClientRect().width + 'px');
        btn.style.setProperty('--add', add + 'px');
    });
};

window.onload = () => {
    btnsShape();
};
